export default {
  label: "Settings",
};
